<template>
    <floating-menu :visible="shouldShow" :position="{bottom: '20px'}">
        <ul>
            <li>
                <ui-icon-button
                    @click="$emit('reply')"
                    icon="reply"
                    type="secondary"
                    style="vertical-align: middle;"
                    tooltip="Reply"
                />
            </li>
            <li>
                <ui-icon-button
                    @click="$emit('note')"
                    icon="comment"
                    type="secondary"
                    style="vertical-align: middle;"
                    tooltip="Add Note"
                />
            </li>
            <li>
                <assign-button
                    :assigned-users="[]"
                    :available-users="$store.getters['inbox/messageBoxes/users']"
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <status-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <tag-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <message-box-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
            <li>
                <download-button
                    :conversations="selected"
                    @changed="conversationsChanged"
                />
            </li>
        </ul>
    </floating-menu>
</template>

<script>
    import AssignButton from "./AssignButton"
    import StatusButton from './StatusButton'
    import MessageBoxButton from "./MessageBoxButton";
    import TagButton from "./TagButton";
    import FloatingMenu from "../elements/FloatingMenu";
    import DownloadButton from "./DownloadButton.vue";

    export default {
        components: {DownloadButton, FloatingMenu, TagButton, AssignButton, StatusButton, MessageBoxButton },
        props: {
            selected: {
                type: Array,
                required: true
            }
        },
        computed: {
            shouldShow() {
                return true
            },
        },
        methods: {
            conversationsChanged() {
                this.$emit('changed')
                this.$store.dispatch('user/badges/update')
            }
        }
    }
</script>